import { searchCity, searchCountry } from 'modules/locations/reducers/worldLocation';

import type { Dispatch, MixedSelectDropdownItem } from 'types';

export function countrySearchToDropdownItems(query: string): Promise<Array<MixedSelectDropdownItem>> {
  return searchCountry(query)()
    .then((countries) =>
      countries.map((country) => ({
        identifier: country.countryCode,
        isDisabled: false,
        isFocused: false,
        isSelected: false,
        label: country.country,
        value: country.country
      }))
    );
}

export function wrappedCitySearchToDropdownItems(
  dispatch: Dispatch
): (a: string) => Promise<Array<MixedSelectDropdownItem>> {
  return query => dispatch(searchCity(query))
    .then(cities =>
      cities.map(city => ({
        identifier: String(city.id),
        isDisabled: false,
        isFocused: false,
        isSelected: false,
        label: city.fullName,
        labelWhenSelected: city.city,
        value: `${city.city}${encodeURIComponent('|')}${city.state}${encodeURIComponent('|')}${city.country}`,
        data: city
      }))
    );
}
